// ── Shared mutable singleton for per-user custom colors (user_colors фича, 2026-07-13) ──
// Mirrors TEAM_NAMES_REF (src/lib/team-names.js) 1:1 — same singleton-ref pattern:
//   • READ by getPersonColor (src/utils.js) — `.current.get(name)`, FIRST link in the
//     resolution chain (wins over the legacy PEOPLE_COLORS map + hash-fallback below it).
//   • WRITTEN by App.jsx — the same "Keep TEAM_NAMES in sync" effect that already
//     watches users[] (fires on every WS-push of the users table) additionally sets
//     `USER_COLORS_REF.current = new Map(users.filter(u => u.color).map(u => [u.name, u.color]))`.
// ESM module-singleton guarantees the writer (App.jsx) and every reader (utils.js,
// AdminPanel.jsx, Settings/index.jsx) share the SAME Map object — a mutation in
// App.jsx is visible everywhere immediately, no prop-drilling needed (see
// docs/design/_brief_user_colors.md §2.2).
export const USER_COLORS_REF = { current: new Map() };
